import React, { useCallback, useEffect } from 'react';
import { Typography } from '@material-ui/core';

export default function LogoutView(props) {
  const logout = useCallback(async () => {
    const search = window.location.search;

    const response = await fetch("/api/account/logout" + search);
    const data = await response.json();

    window.location.replace(data.redirectUrl);
  }, []);

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <Typography>
      Please wait ...
    </Typography>
  );
};